<nav class="mobile-bottom-nav" aria-label="Primary">
    <button
        *ngFor="let item of items; trackBy: trackById"
        type="button"
        class="mobile-bottom-nav__tab"
        [class.mobile-bottom-nav__tab--active]="item.id === selectedId"
        [attr.aria-current]="item.id === selectedId ? 'page' : null"
        (click)="itemSelected.emit(item)"
    >
        <!--
            The badge hangs on this wrapper, not on the icon: mat-badge renders
            its count as a CHILD of the host, and the svg tabs' host is an <img>
            — a replaced element, whose children a browser never paints. The
            Inbasket count was invisible that way even once it held the right
            value (OE-97).
        -->
        <span
            class="mobile-bottom-nav__icon-wrap"
            [matBadge]="item.count"
            [matBadgeHidden]="!item.showCount || !item.count"
            matBadgeSize="small"
            matBadgeColor="warn"
        >
            <img
                *ngIf="item.svg; else iconTpl"
                class="mobile-bottom-nav__icon mobile-bottom-nav__icon--svg"
                [attr.src]="'/assets/icons/' + item.svg"
                alt=""
            />
            <ng-template #iconTpl>
                <mat-icon class="mobile-bottom-nav__icon">{{ item.icon }}</mat-icon>
            </ng-template>
        </span>
        <span class="mobile-bottom-nav__label">{{ item.name }}</span>
    </button>
</nav>
